import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const FinalCTA = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // Trigger modal by dispatching custom event or just scroll to hero
    setTimeout(() => {
      const ctaBtn = document.querySelector('[data-testid="explore-csr-btn"]');
      if (ctaBtn) ctaBtn.click();
    }, 500);
  };

  return (
    <section className="cta-band py-12 md:py-14" data-testid="final-cta-section">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center text-white">
          {/* Urgency Line */}
          <p className="text-[#F4C430] text-xs font-semibold uppercase tracking-wider mb-3">
            FY 2025–26 allocation window closing soon
          </p>
          
          <h2 className="font-display text-xl md:text-2xl font-bold mb-4">
            Start a CSR Conversation with the Co-Founders
          </h2>
          
          <Button
            onClick={scrollToTop}
            className="bg-white text-[#1F7A5A] hover:bg-white/90 font-semibold px-6 py-5 text-sm rounded-lg"
            data-testid="final-cta-btn"
          >
            Start a CSR Conversation
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
          
          <p className="mt-4 text-white/70 text-xs max-w-md mx-auto">
            Schedule a structured alignment discussion within the FY 2025–26 CSR cycle.
          </p>
          
          <p className="mt-6 text-white/50 text-xs italic">
            Leaving care should not mean leaving opportunity.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
